import { Image } from "@react-pdf/renderer";
import { useMemo } from "react";

const PdfImage = ({ src, width = 200, height = 60, style = {} }) => {
  const styles = useMemo(() => {
    return {
      width,
      height,
      ...style,
    };
  }, [width, height, style]);

  return <Image style={styles} src={src} />;
};

export default PdfImage;
